module.exports = __webpack_public_path__ + "static/media/4.ae37aed1.png";